import { Routes } from '@angular/router';

import { adminGuard } from './auth/guards/admin.guard';
import { authGuard } from './auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./screens/landing-page/landing-page.routes').then((m) => m.landingPageRoutes),
  },
  {
    path: 'login-page',
    loadComponent: () => import('./screens/auth/login-page/login-page').then((m) => m.LoginPage),
  },
  {
    path: 'register-success',
    loadComponent: () =>
      import('./screens/auth/registration-success/registration-success').then(
        (m) => m.RegistrationSuccess,
      ),
  },
  {
    path: 'email-confirmation',
    loadComponent: () =>
      import('./screens/auth/email-confirmation/email-confirmation').then(
        (m) => m.EmailConfirmation,
      ),
  },
  {
    path: 'user-settings',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./screens/user-settings/user-settings').then((m) => m.UserSettings),
  },
  {
    path: 'advanced-search',
    loadChildren: () =>
      import('./screens/advanced-search/advanced-search.routes').then(
        (m) => m.ADVANCED_SEARCH_ROUTES,
      ),
  },
  {
    path: 'admin-panel',
    canActivate: [authGuard, adminGuard],
    loadComponent: () => import('./screens/admin-panel/admin-panel').then((m) => m.AdminPanel),
  },
  {
    path: 'create-listing',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./listings/components/create-listing-shell/create-listing-shell').then(
        (m) => m.CreateListingShell,
      ),
  },
  {
    path: 'view-listing',
    loadComponent: () =>
      import('./screens/view-listing/view-listing').then((m) => m.ViewListingComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
